import React, { ReactNode } from 'react';
import { SEOBreadcrumbs } from 'common/components';
import { RootPageStyles } from './styles';

export const RootPage = ({ children }: { children: ReactNode }) => (
	<div className={RootPageStyles}>
		{children}
		<SEOBreadcrumbs />
	</div>
);
